// Copyright © 2021 Move Closer
import { computed, ref } from '@vue/composition-api';
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const dropdownItemProps = {
    item: {
        type: Object,
        required: true
    }
};
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export function useDropdownItem(props, ctx) {
    const isLoading = ref(false);
    const isClickable = computed(() => typeof props.item.onClick === 'function');
    const onClick = () => {
        if (isClickable.value) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            const result = props.item.onClick();
            if (result instanceof Promise) {
                isLoading.value = true;
                result.then(() => {
                    isLoading.value = false;
                    ctx.emit('click');
                });
            }
            else {
                ctx.emit('click');
            }
        }
    };
    return { isClickable, isLoading, onClick };
}
